import React from 'react';
import { Link } from 'react-router-dom';
import { SeoManager } from '../seo';
import '../styles/NotFoundPage.css';

const NotFoundPage = () => {
  return (
    <div className="not-found-container">
      <SeoManager
        title="Page Not Found - Type Click Tests"
        description="This page does not exist. Go back to typing tests, click tests, and games on Type Click Tests."
        noindex
      />
      <div className="content">
        <h1 className="glitch" data-text="404">404</h1>
        <h2>Page not found</h2>
        <p>That link is missing or out of date. Try one of these instead:</p>
        <div className="not-found-links">
          <Link to="/" className="home-link">Home</Link>
          <Link to="/60s-cpm-typing-test/" className="home-link">1 minute typing test</Link>
          <Link to="/5s-cps-click-test/" className="home-link">5 second CPS test</Link>
          <Link to="/higher-or-lower/" className="home-link">Higher or Lower</Link>
          <Link to="/blog/" className="home-link">Blog</Link>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
